module.exports = __webpack_public_path__ + "img/home1-6.5b9d6563.jpg";